'use strict';

var es2015 = require('./es2015.js');

var es6 = es2015;

module.exports = es6;
